const initialState = {
  homeMenuLinks: [
    { url: "#", title: "products" },
    { url: "#", title: "industries" },
    { url: "#", title: "company" },
    { url: "/login", title: "login" },
  ],
  dropdownLinks: [
    { url: "#", title: "my credit" },
    { url: "#", title: "latest payements" },
  ],
  LgDropDownLinks: [
    { abrrev: "en", title: "English" },
    { abrrev: "ar", title: "عربي" },
    { abrrev: "ko", title: "한국어" },
  ],
  sidebarVisible: true,
  dropdownOpen: false,
  lgDropDown: false,
  notificationsOpen: false,
  notifications: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  errors: [],
  success: null,
  isAppBarScrolled: false,
};

const layoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case "OPEN_SIDE_BAR":
      return { ...state, sidebarVisible: true };
    case "CLOSE_SIDE_BAR":
      return { ...state, sidebarVisible: false };
    case "TOGGLE_SIDE_BAR":
      return { ...state, sidebarVisible: !state.sidebarVisible };

    case "OPEN_NOTIFICATIONS":
      return { ...state, notificationsOpen: true };
    case "CLOSE_NOTIFICATIONS":
      return { ...state, notificationsOpen: false };
    case "TOGGLE_NOTIFICATIONS":
      return { ...state, notificationsOpen: !state.notificationsOpen };

    case "OPEN_DROPDOWN":
      return { ...state, dropdownOpen: true };

    case "CLOSE_DROPDOWN":
      return { ...state, dropdownOpen: false };

    case "OPEN_LG_DROP":
      return { ...state, lgDropDown: true };

    case "CLOSE_LG_DROP":
      return { ...state, lgDropDown: false };
    case "CONTACT_SUCCESS":
      return { ...state, success: action.payload };
    case "CLEAR_SUCCESS":
      return {
        ...state,
        success: null,
      };
    case "ADD_ERROR":
      return { ...state, errors: [...state.errors, action.payload] };
    case "REMOVE_ERROR":
      return {
        ...state,
        errors: [
          state.errors.filter((error, i) => i !== action.payload && error),
        ],
      };
    case "CLEAR_ERRORS":
      return {
        ...state,
        errors: [],
      };
    case "CHANGE_APP_BAR_STYLE": 
    return {
      ...state, isAppBarScrolled : true 
    };
    case "RESET_APP_BAR_STYLE": 
    return {
      ...state, isAppBarScrolled : false 
    }
    default:
      return state;
  }
};

export default layoutReducer;
